module.exports = __webpack_public_path__ + "static/media/tool.a8d814c9.svg";